import { cn } from '@/utils/utils';
import type { TreeItem } from './types';

type GetStatusClassnames = {
  isOverFolder: boolean;
  isSelected: boolean;
  isDragging: boolean;
  clone?: boolean;
  tree: TreeItem;
  isActive?: boolean;
};

export const getStatusClassnames = ({
  isOverFolder,
  isSelected,
  isDragging,
  clone,
}: GetStatusClassnames) => {
  return cn(
    'w-full justify-start text-foreground focus-visible:!outline-none focus-visible:!ring-0 focus-visible:ring-offset-0 hover:bg-muted',
    isDragging && 'h-1 py-0 block bg-badgeLightBlue [&>*]:hidden relative z-20',
    isSelected &&
      'bg-badgeLightBlue hover:bg-badgeLightBlue outline-2 outline-background outline',
    isOverFolder && 'bg-badgeLightBlue',
    clone && 'border border-border shadow-feint bg-background',
  );
};
